module.exports = __webpack_public_path__ + "static/media/uy.fb46025c.png";